import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMembers = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 18.11,
			cy: 12.38,
			r: 2.38,
			style: { fill: "currentColor" }
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 5.89,
			cy: 12.38,
			r: 2.38,
			style: { fill: "currentColor" }
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 11.95,
			cy: 8.89,
			r: 2.89,
			style: { fill: "currentColor" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm5,16a5.34,5.34,0,0,1,.4,2,.5.5,0,0,1-1,0,4.39,4.39,0,0,0-8.78,0,.5.5,0,0,1-1,0A5.34,5.34,0,0,1,7,16a4.94,4.94,0,0,0-3.86.7A10,10,0,1,1,22,12a9.9,9.9,0,0,1-1.16,4.66A4.91,4.91,0,0,0,17,16Z",
			style: { fill: "currentColor" }
		})
	] })
});
export { SvgMembers as ReactComponent };
